class LoroPianaBanner extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('[data-lp-banner-play]');
    this.muteButton = this.querySelector('[data-lp-banner-mute]');

    if (!this.video) {
      this.querySelector('[data-lp-banner-controls]')?.setAttribute('hidden', '');
      return;
    }

    this.playButton?.addEventListener('click', this.togglePlayback);
    this.muteButton?.addEventListener('click', this.toggleMute);
    this.video.addEventListener('play', this.updatePlaybackState);
    this.video.addEventListener('pause', this.updatePlaybackState);

    this.updatePlaybackState();
    this.updateMuteState();
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.togglePlayback);
    this.muteButton?.removeEventListener('click', this.toggleMute);
    this.video?.removeEventListener('play', this.updatePlaybackState);
    this.video?.removeEventListener('pause', this.updatePlaybackState);
  }

  togglePlayback = () => {
    if (!this.video) return;

    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }

    this.updatePlaybackState();
  };

  toggleMute = () => {
    if (!this.video) return;

    this.video.muted = !this.video.muted;
    this.updateMuteState();
  };

  updatePlaybackState = () => {
    const isPlaying = Boolean(this.video && !this.video.paused);

    this.playButton?.setAttribute('aria-pressed', String(!isPlaying));
    this.playButton?.setAttribute('data-playing', String(isPlaying));
    this.playButton?.setAttribute('aria-label', isPlaying ? 'Pause banner video' : 'Play banner video');
  };

  updateMuteState = () => {
    const isMuted = Boolean(this.video?.muted);

    this.muteButton?.setAttribute('aria-pressed', String(isMuted));
    this.muteButton?.setAttribute('data-muted', String(isMuted));
    this.muteButton?.setAttribute('aria-label', isMuted ? 'Unmute banner video' : 'Mute banner video');
  };
}

if (!customElements.get('loro-piana-banner')) {
  customElements.define('loro-piana-banner', LoroPianaBanner);
}
